module.exports = __webpack_public_path__ + "static/media/redemption-failed-user.aff3971a.svg";